import React from 'react';
import PropTypes from 'prop-types';
// import Button from '../Button/Button';
import './ActionButton.css';

const ActionButton = ({ icon: Icon, onClick, title, className = '', disabled = false }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick && !disabled) {
      onClick(e);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={className}
      title={title}
      type="button"
      ariaLabel={title}
      disabled={disabled}
    >
      {Icon && <Icon />}
    </button>
  );
};

ActionButton.propTypes = {
  icon: PropTypes.elementType.isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ActionButton;
